export default "__VITE_ASSET__BgER1Es1__"